import axios from "axios";
import config from "../config";
import { ApiSuccess } from "./api_helper";

const apiBase = config.api.API_URL;

export type DeliverabilityBand = "good" | "attention" | "risk";

export type DeliverabilityFinding = {
  code: string;
  severity: "info" | "warn" | "critical";
  message: string;
  hint: string | null;
};

export type DeliverabilityCheckResult = {
  rules_version: number;
  band: DeliverabilityBand;
  score: number;
  findings: DeliverabilityFinding[];
};

/**
 * Pré-voo síncrono — sem cota; overrides para draft não salvo.
 * DOC 04 § 4.8.2.
 */
export const checkCampaignDeliverability = (
  campaignId: number,
  overrides?: { subject?: string; html_body?: string }
): Promise<ApiSuccess<DeliverabilityCheckResult>> => {
  return axios.post(
    `${apiBase}/campaigns/${campaignId}/deliverability-check`,
    overrides ?? {}
  );
};

/**
 * Pré-voo sem campanha (JWT) — subject+html obrigatórios (LAC-125).
 */
export const checkStandaloneDeliverability = (payload: {
  subject: string;
  html_body: string;
}): Promise<ApiSuccess<DeliverabilityCheckResult>> => {
  return axios.post(`${apiBase}/deliverability-check`, payload);
};

/** Extrai hrefs trackáveis do HTML (editor — link goal). */
export const extractTrackableUrlsFromHtml = (html: string): string[] => {
  const seen = new Set<string>();
  const out: string[] = [];
  const re = /<a\b[^>]*href\s*=\s*(["'])(.*?)\1/gi;
  let m: RegExpExecArray | null;
  while ((m = re.exec(html)) !== null) {
    const url = m[2].trim();
    if (!url || url.startsWith("{{") || url.startsWith("#")) {
      continue;
    }
    const lower = url.toLowerCase();
    if (
      lower.startsWith("mailto:") ||
      lower.startsWith("tel:") ||
      lower.startsWith("sms:") ||
      lower.startsWith("javascript:") ||
      lower.startsWith("data:")
    ) {
      continue;
    }
    if (!seen.has(url)) {
      seen.add(url);
      out.push(url);
    }
  }
  return out;
};
